import React from 'react';
import PropTypes from 'prop-types';
import ContentGroupTabs from './ContentGroupTabs';
import { getSectionsData } from './helpers';

const ContentGroup = ({ contentType, children, ...props }) => {
  const groupSections = children?.props?.children[1];
  if (!groupSections || !groupSections.length) return '';
  if (contentType !== 'tab' && contentType !== 'sidepanel') return '';
  const sectionsData = getSectionsData(groupSections);

  return (
    <ContentGroupTabs
      contentType={contentType}
      groupSections={groupSections}
      sectionsData={sectionsData}
      {...props}
    />
  );
};

ContentGroup.propTypes = {
  children: PropTypes.object.isRequired,
  contentType: PropTypes.string.isRequired
};

ContentGroup.defaultProps = {};

export default ContentGroup;
